module.exports = {
  Range: 'Диапазон',
  SorryHavePermissionToInformation: 'Извините! У вас нет прав для просмотра подробностей.',
  BusinessInformationSelectionIncorrect: 'Неправильно выбрана информация о бизнесе.',
  DidOnThePreviousDay: 'Не прошли таможенное оформление накануне',
  DeclaredSameDayAsFlight: 'Таможенное оформление и рейс в тот же день',
  DeclaredOnTheSameDay: 'Таможенное оформление в тот же день',
  Other: 'Другое',
  PleaseTheCustomsDeclarationList: 'Пожалуйста, выберите список таможенного оформления.',
  LabelPrintingSucceeded: 'Метка успешно напечатана.',
  ConfirmAudit: 'Подтвердить проверку?',
  PleaseTheMasterBillInformation: 'Пожалуйста, выберите информацию о главной накладной.',
  TheNumberHasBeenInvalidated: 'Этот номер главной накладной уже аннулирован.',
  CancellationSuccessful: 'Аннулирование успешно.',
  CancellationFail: 'Аннулирование не удалось.',
  ConfirmBillNumberFromBusiness: 'Подтверждаете отмену привязки этого номера главной накладной к бизнесу?',
  UnbindingFailed: 'Отмена привязки не удалась.',
  UnbindingSuccessful: 'Отмена привязки успешна.',
  MasterBill: 'Главная накладная',
  SubBill: 'Дополнительная накладная',
  MasterBillStatus: 'Статус главной накладной',
  SubBillStatus: 'Статус дополнительной накладной',
  EnterQueryInformation: 'Пожалуйста, введите информацию для запроса!',
  ConfirmThis: 'Подтвердить это',
  ReceiptNumber: 'Номер возвратной накладной',
  AllFlightMustBeLocking: 'Все заказы текущего рейса должны быть отправлены перед блокировкой!',
  OtherDocuments: 'Другие документы',
  CustomsDeclarationDocuments: 'Таможенные документы',
  PleaseImageYouWantUpload: 'Пожалуйста, выберите изображение для загрузки.',
  InvalidReceiptNumber: 'Недействительный номер квитанции!',
  InvalidMasterBillNumber: 'Недействительный номер главной накладной.',
  NoContactTheAirlineImages: 'Этот номер накладной не привязан к рейсу, свяжитесь с авиалинией для привязки перед загрузкой изображений.',
  PleaseFileYouWantDownload: 'Пожалуйста, выберите файлы для скачивания.',
  UploadWantToUploadImage: 'Загрузка успешна, загрузить фото следующего номера?',
  BulkEditingDestinationPortInformation: 'Массовое изменение информации о порте назначения',
  OverseasWarehouseNonAmazonWarehouse: 'Зарубежный транзитный склад (не Amazon)',
  EstimatedArrivalTime: 'Предполагаемое время доставки',
  ActualArrivalTime: 'Фактическое время доставки',
  NoDataSelected: 'Данные не выбраны',
  AllAreInNonState: 'Все выбранные записи данных находятся в нерабочем состоянии',
  TheIsNotSelfConsolidation: 'Тип консолидации этого бизнеса не является самоконсолидацией, buyer consol или доверенной консолидацией',
  AttachmentTooLarge: 'Содержимое вложения слишком большое',
  BusinessStatusChangeLog: 'Журнал изменений статуса бизнеса',
  DomesticWarehouse: 'Внутренний склад',
  OverseasWarehouse: 'Зарубежный склад',
  LogRecords: 'Запись журнала',
  GeneralTrade: 'Обычная торговля',
  OperationSuccessful: 'Операция успешна',
  PleaseChooseAnAirline: 'Пожалуйста, выберите авиалинию!',
  ContainerType: 'Тип контейнера',
  Size: 'Модель контейнера',
  LockedPleaseContactSupervisorUnlocking: 'Заблокировано, печать невозможна. Обратитесь к руководителю для разблокировки!',
  ProfitAnalysisPrint: 'Печать анализа прибыли',
  DoCopyMasterBillInformation: 'Подтверждаете копирование информации об отправителе/получателе из главной накладной?',
  DeleteSucceeded: 'Успешно удалено!',
  PleaseFormatOfTheLengthwidthheightquantity: 'Введите размеры в правильном формате: длина*ширина*высота*количество!',
  GenerationFailed: 'Ошибка генерации!',
  CargoCollectionType: 'Тип забора груза',
  Commission: 'Поручение',
  CustomsClearanceMethod: 'Способ таможенного оформления',
  ServiceChannel: 'Сервисный канал',
  ExpectedTimeIntoAmazonWarehouse: 'Планируемое время поступления на склад Amazon',
  ZipCode: 'Почтовый индекс',
  DestinationDeliveryMethod: 'Способ доставки в пункте назначения',
  ExpressCompany: 'Курьерская компания',
  CourierNumber: 'Трек-номер',
  POOriginalOrderNumber: 'PO (оригинальный номер)',
  EORIBusinessNumber: 'EORI номер предприятия',
  VATTaxNumber: 'НДС/ИНН',
  VATRegistrationCountry: 'Страна регистрации НДС',
  VATRegistrationAddress: 'Адрес регистрации НДС',
  VATCompanyEnglishName: 'Английское название компании для НДС',
  EstimatedDeliveryTime: 'Планируемое время доставки',
  ActualDeliveryTime: 'Фактическое время доставки',
  WithBattery: 'С батареей',
  WithMagnet: 'Магн.',
  Powder: 'Пор.',
  Liquid: 'Жидк.',
  EstimatedStorageGoodArrivalTime: 'Планируемое время поступления на склад/готовности товара',
  RemoteWarehouse: 'Удаленный склад',
  AirFreight: 'Авиаперевозка',
  FeeType: 'Тип расходов:',
  EstimatedAmount: 'Ориентировочная сумма:',
  Equivalent: 'Эквивалент',
  FreightRateLevel: 'Тарифный класс:',
  BilledWeight: 'Платный вес:',
  CalculationMethod: 'Способ расчета:',
  EstimatedTimeCannotBeEmpty: 'Планируемое время поступления на склад/готовности товара не может быть пустым!',
  DestinationCannotBeEmpty: 'Пункт назначения не может быть пустым!',
  DestinationCountryCannotBeEmpty: 'Страна назначения не может быть пустой!',
  ZipCodeCannotBeEmpty: 'Почтовый индекс не может быть пустым!',
  CannotBeEmpty: 'Не может быть пустым!',
  InvalidBillNumberCannotBind: 'Недействительный номер главной накладной, привязка невозможна!',
  PleaseTheConsignorUnitFirst: 'Сначала выберите организацию-поручителя.',
  TheExpensesCanNotMode: 'У текущей накладной есть распределенные расходы, переключение режима невозможно!',
  DoRefreshTheMAWBInformation: 'Обновить информацию, связанную с MAWB?',
  CourierCompany: 'Курьерская компания',
  ForeignWarehouse: 'Зарубежный склад',
  CustomsDeclarationMethod: 'Способ таможенного декларирования',
  TheSharedExpensesCanSeparate: 'У текущей накладной есть распределенные расходы, разделение невозможно!',
  RemoveTicketSuccessfully: 'Накладная успешно удалена!',
  AttachmentDescription: 'Примечание к вложению:',
  AirlineCannotBeEmpty: 'Авиакомпания не может быть пустой',
  AddNew: 'Добавить',
  NoItemDetailsSelected: 'Детали груза не выбраны!',
  SellingPriceCalculationCompleted: 'Расчет продажной цены завершен',
  PleaseSelectWarehouseEntryData: 'Пожалуйста, выберите данные о поступлении на склад!',
  DeletedSuccessfully: 'Удаление успешно!',
  PleaseAPieceOfData: 'Пожалуйста, выберите одну запись!',
  CustomsClearanceTracking: 'Отслеживание таможенного оформления',
  CustomsClearanceQuantity: 'Количество мест по таможне',
  CustomsClearanceWeight: 'Вес по таможне',
  CustomsClearanceDate: 'Дата таможенного оформления',
  CustomsClearanceInformation: 'Информация о таможенном оформлении',
  MultipleCustomsDeclarations: 'Несколько таможенных деклараций',
  WhetherApplyForCommercialInspection: 'Подлежит ли товарному контролю',
  WhetherToCheck: 'Подлежит ли досмотру',
  PleaseSelectCustomsClearanceInformation: 'Пожалуйста, выберите информацию о таможенном оформлении.',
  TheBeEqualToBusiness: 'Суммарный вес по таможне должен соответствовать фактическому весу груза.',
  NextLegEntry: 'Ввод продолжения маршрута',
  ActualFlight: 'Фактический рейс:',
  NextLegInformation: 'Информация о продолжении маршрута:',
  ActualFlightCannotBeEmpty: 'Фактический рейс не может быть пустым.',
  ActualDepartureDate: 'Фактическая дата отправления.',
  NextInformationCannotBeEmpty: 'Информация о продолжении маршрута не может быть пустой.',
  BatchModificationOfReportStatus: 'Массовое изменение статуса отчетов',
  CustomsClearanceStatus: 'Статус таможенного оформления:',
  PleaseSelectCustomsClearanceStatus: 'Пожалуйста, выберите статус таможенного оформления.',
  SelectAirPort: 'Выбор авиационного порта',
  PleaseSelectAPort: 'Пожалуйста, выберите порт!',
  FlightSelection: 'Выбор рейса',
  Monday: 'Понедельник',
  Tuesday: 'Вторник',
  Wednesday: 'Среда',
  Thursday: 'Четверг',
  Friday: 'Пятница',
  Saturday: 'Суббота',
  Sunday: 'Воскресенье',
  FlightSchedule: 'Расписание рейсов',
  Weekly: 'Еженедельно',
  PleaseSelectAFlight: 'Пожалуйста, выберите рейс.',
  PleaseEnterACode: 'Пожалуйста, введите код!',
  CodeExistsPleaseReEnter: 'Код уже существует, пожалуйста, введите заново!',
  PleaseEnterAName: 'Пожалуйста, введите название!',
  PleaseAddARegionalPort: 'Пожалуйста, добавьте региональный порт!',
  AreYouWantToDelete: 'Вы уверены, что хотите удалить?',
  PleaseTheDepartureRegionCode: 'Пожалуйста, введите код региона отправления!',
  PleaseTheDestinationRegionCode: 'Пожалуйста, введите код региона назначения!',
  DepartureRegionCodeCannotSame: 'Код региона отправления и код региона назначения не могут совпадать!',
  WeeklySchedule: 'Расписание',
  PleaseEffectiveDateStartTime: 'Пожалуйста, выберите время начала действия!',
  PleaseSelectTheSchedule: 'Пожалуйста, выберите расписание!',
  PleaseEnterTheTransshipmentPort: 'Введите порт перевалки.',
  AreWantToDeleteRoute: 'Вы уверены, что хотите удалить маршрут?',
  GenerateFlight: 'Сформировать рейс',
  PleaseEnterAFlightNumber: 'Введите номер рейса!',
  PleaseEnterAnAirline: 'Введите авиакомпанию!',
  PleaseEnterTheDeparturePort: 'Введите порт отправления!',
  PleaseEnterTheDestinationPort: 'Введите порт назначения!',
  PleaseDepartureTimeForWeek: 'Введите неделю',
  AreWantToDeleteFlight: 'Вы уверены, что хотите удалить рейс?',
  TheWantToDeleteRegenerate: 'Рейс уже сформирован. Удалить исходные данные и сформировать заново?',
  GenerationSuccessful: 'Успешно сформировано.',
  AtBookingNatureAirportEntered: 'Необходимо заполнить хотя бы одно из полей: маршрут, авиакомпания, тип бронирования, аэропорт, продажи!',
  ResponsibilitiesAssignedNoDeletionAllowed: 'Обязанности уже распределены, удаление запрещено!',
  AreToDeleteThisRecord: 'Вы уверены, что хотите удалить эту запись?',
  TheTheAirlineIsModify: 'Ошибка в трехбуквенном коде авиакомпании, исправьте!',
  PleaseSelectAnAirline: 'Выберите авиакомпанию!',
  PleaseSelectTheExpirationDate: 'Выберите дату истечения срока!',
  PleaseStartingMasterBillNumber: 'Введите начальный номер главной накладной!',
  TheLegalThereIsAirline: 'Неверный начальный номер, нет соответствующей авиакомпании!',
  TheNumberIsNotLegal: 'Неверный номер главной накладной!',
  PleaseTheDateOfPossession: 'Выберите дату получения!',
  TheMasterBillMayExist: 'Номера главных накладных в этом диапазоне уже могут существовать!',
  ConfirmDeleteTheMasterBill: 'Подтверждаете удаление главной накладной?',
  CancelSubmission: 'Отменить отправку',
  SaveSuccessfully: 'Успешно сохранено!',
  SaveSuccess: 'Успешно сохранено',
  PleaseTheWarehouseEntryNumber: 'Введите номер складского размещения!',
  PleaseWeightOfTheSeal: 'Выберите вес пломбы!',
  PleaseEnterTheWarehouseName: 'Введите название склада!',
  ReviewSucceeded: 'Проверка успешно завершена!',
  LockedContactAHigherUnlock: 'Заблокировано, печать невозможна. Обратитесь к руководителю для разблокировки!',
  PleasePortOfDepartureDestination: 'Введите порт отправления или назначения!',
  SaveFileFormatIsIncorrect: 'Ошибка сохранения, неверный формат Excel-файла!',
  SuccessfullyImported: 'Успешно импортировано',
  PiecesOfData: 'записей!',
  SaveFailed: 'Ошибка сохранения!',
  PleaseThePortOfDeparture: 'Введите порт отправления!',
  CompleteOperationRequirements: 'Выполнить операционные требования',
  PleaseSelectTheCompletionTime: 'Выберите время завершения.',
  CurrentlySelected: '(Текущий выбор)',
  CurrentPage: '(Текущая страница)',
  CompletionStatus: 'Статус выполнения',
  Completed: 'Завершено',
  Uncompleted: 'Не завершено',
  OperationRequirementDescription: 'Описание операционных требований',
  CurrentSelectionIncludesCompletedStatus: 'Текущий выбор включает завершенные статусы.',
  OperationRequirementTracking: 'Отслеживание операционных требований',
  ConfirmCancellation0: 'Подтверждаете аннулирование номера [{0}]?',
  DeDepartureTime: 'время вылета.',
  AERequiredChecksum: 'Обязательно заполнить один из параметров: начальный номер главной накладной или массовое добавление',
  FlightInformation: 'Информация о рейсе',
  TrackingDetails: 'Детали отслеживания груза',
  StartingStation: 'Пункт отправления',
  DestinationStation: 'Пункт назначения',
  FlightNumber: 'Номер рейса',
  DepartureTime: 'Время отправления',
  ArrivalTime: 'Время прибытия',
  Pieces: 'Количество мест',
  Weight: 'Вес',
  Time: 'Время',
  Status: 'Статус',
  Airport: 'Аэропорт',
  Unknown: 'Неизвестно',
  BKD: 'Бронирование места',
  RCS: 'Загрузка на склад',
  MAN: 'Планирование загрузки',
  DEP: 'Вылет',
  ARR: 'Прибытие',
  AWD: 'Прием документов',
  RCF: 'Разгрузка',
  NFD: 'Уведомление о прибытии груза',
  DLV: 'Получение груза',
  TAR: 'Прибытие на транзит',
  TDE: 'Вылет с транзита',
  TRF: 'Разгрузка на транзите',
  RWB: 'Прием документов',
  CUS: 'Таможенное оформление',
  AeMawbChargeWeight: 'Расчетный вес для авианакладной',
  AeBookingChargeWeight: 'Расчетный вес для бронирования авиаперевозки',
  MawbChargeWeight: 'Расчетный вес для оформления',
  BookingChargeWeight: 'Расчетный вес для бронирования',
  ImportBoardInstallInfo: 'Имп. загр. паллет',
  PleaseImportCorrectTemplate: 'Пожалуйста, импортируйте данные по корректному шаблону',
  ClickDownloadTemplate: 'Можно скачать шаблон, нажав здесь',
  AsyncUploadLogView: 'Эта операция выполняется асинхронно, результаты импорта можно посмотреть в "Хранилище файлов -> Журнал загрузок"',
  ServiceInformation: 'Сервисная информация',
  ControlDisplayConfiguration: 'Конфигурация отображения элементов управления',
  WovenFabricorder: 'Ткань (заказ)',
  BookingForCargobooking: 'Бронирование для груза (бронирование)',
  ItemMaoTiForwardWarehouseActual: 'Товарный毛 (форвард-склад (фактический))',
  ItemMaoTiOrderProcessing: 'Элемент毛 тела (обработка заказа)'
}
